module.exports = __webpack_public_path__ + "img/shape1.27038015.svg";